import React, { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Tooltip,
  Box
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import bprmFieldSx from "./bprmFieldSx";

const OtherTextField = (props) => {
  const {
    label,
    name,
    isDisabled,
    codeIsVerified,
    value: propValue,
    handleOnChange,
    onMouseEnter,
  } = props;

  const [encryptDecrypt, setEncryptDecrypt] = useState(true);
  const [decryptValue, setDecryptValue] = useState("");
  const [valueArray, setValueArray] = useState([]);

  useEffect(() => {
    const strVal = propValue !== null && propValue !== undefined ? String(propValue) : "";
    if (strVal !== "") {
      // Clean any leaked mask asterisks that may have been saved previously
      const cleanStr = strVal.replace(/\*/g, "");
      let newValueArray = [];
      let newDecValue = "";

      for (let index = 0; index < cleanStr.length; index++) {
        const element = cleanStr[index];
        newValueArray.push(element);
        newDecValue += "*";
      }

      setValueArray(newValueArray);
      if (encryptDecrypt) {
        setDecryptValue(newDecValue);
      } else {
        setDecryptValue(cleanStr);
      }

      // If propValue contained leaked asterisks, heal the stateData in parent
      if (strVal.includes("*") && handleOnChange) {
        handleOnChange(name, newValueArray);
      }
    } else {
      setValueArray([]);
      setDecryptValue("");
    }
  }, [propValue, encryptDecrypt]);

  const handleEncryptOnChange = (input) => {
    const { value, selectionStart } = input.target;

    if (encryptDecrypt) {
      if (value === "") {
        setValueArray([]);
        setDecryptValue("");
        handleOnChange(name, []);
        return;
      }

      const typedChars = value.replace(/\*/g, "");
      let newValueArray = [...valueArray];

      if (value.length < valueArray.length) {
        // Characters deleted (via backspace, delete, or range deletion)
        const diff = valueArray.length - value.length;
        newValueArray.splice(selectionStart, diff);
      } else {
        // Characters inserted or replaced
        const insertIndex = Math.max(0, (selectionStart || 0) - typedChars.length);
        const deletedCount = valueArray.length - (value.length - typedChars.length);
        if (deletedCount > 0) {
          newValueArray.splice(insertIndex, deletedCount);
        }
        newValueArray.splice(insertIndex, 0, ...typedChars.split(""));
      }

      setValueArray(newValueArray);
      setDecryptValue("*".repeat(newValueArray.length));
      handleOnChange(name, newValueArray);
    } else {
      const cleanValue = value.replace(/\*/g, "");
      const newArray = Array.from(cleanValue);
      setValueArray(newArray);
      setDecryptValue(cleanValue);
      handleOnChange(name, newArray);
    }
  };

  const handleEncryptValue = () => {
    let decValue = "";
    for (let index = 0; index < valueArray.length; index++) {
      decValue += "*";
    }
    setDecryptValue(decValue);
    setEncryptDecrypt(true);
  };

  const handleDcryptValue = () => {
    let decValue = "";
    for (let index = 0; index < valueArray.length; index++) {
      const element = valueArray[index];
      if (element !== "*") decValue += element;
    }
    setDecryptValue(decValue);
    setEncryptDecrypt(false);
  };

  return (
    <Box display="flex" alignItems="center" width="100%" onMouseEnter={onMouseEnter}>
      <TextField
        fullWidth
        variant="outlined"
        name={name}
        value={decryptValue}
        onChange={handleEncryptOnChange}
        onMouseEnter={onMouseEnter}
        disabled={isDisabled}
        placeholder={label}
        sx={bprmFieldSx}
        inputProps={{
          autoComplete: "off",
          "data-lpignore": "true",
          "data-form-type": "other"
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {!encryptDecrypt ? (
                <Tooltip title="Hide Sensitive Information">
                  <IconButton
                    onClick={handleEncryptValue}
                    edge="end"
                    color="error"
                  >
                    <VisibilityOff />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Show Sensitive Information">
                  <IconButton
                    onClick={handleDcryptValue}
                    edge="end"
                    color="success"
                    disabled={!codeIsVerified}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              )}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default OtherTextField;
